import 'core-js/modules/es.array.every';
import 'core-js/modules/es.array.flat-map';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.object.entries';
import 'core-js/modules/es.object.keys';
import 'core-js/web/dom-collections';
import 'details-element-polyfill';
import 'formdata-polyfill';
import 'zone.js';

(window as any)['global'] = window;
(window as any).process = { env: { DEBUG: undefined } };
